import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _objectSpread from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { validateor, validateInfo } from '@/utils/validate';
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import SchdulePlan from '@/modules/SchdulePlan/index.vue';
import apis from '@/apis/scheduleManage';

var ScheduleCase = /*#__PURE__*/function (_Vue) {
  _inherits(ScheduleCase, _Vue);

  var _super = _createSuper(ScheduleCase);

  function ScheduleCase() {
    var _this;

    _classCallCheck(this, ScheduleCase);

    _this = _super.call(this);
    _this.personList = [];
    _this.confMemberList = [];
    _this.confMemberMax = 6;
    _this.pickerOptions = {
      disabledDate: function disabledDate(time) {
        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
      }
    };
    _this.allSchedule = [];
    _this.loading = true;
    _this.form = {
      chiefJudgeId: '',
      clerkId: '',
      confMember: []
    };
    _this.rule = {
      chiefJudgeId: validateor({
        required: true,
        trigger: 'change'
      }),
      clerkId: [],
      confMember: [{
        required: true,
        message: validateInfo.required,
        trigger: 'change',
        type: 'array'
      }]
    };
    _this.scheduleInfo = {
      relationList: [],
      chiefJudgeId: '',
      clerkId: '',
      caseIndexCodeList: []
    };
    _this.selectInfo = {
      planStartTime: '',
      planEndTime: '',
      tribunalName: '',
      tribunalId: ''
    };
    _this.date = new Date(Date.now() + 24 * 60 * 60 * 1000);
    _this.searchStartTime = _this.$moment(_this.date).format('YYYY-MM-DD 00:00:00');
    _this.searchEndTime = _this.$moment(_this.date).format('YYYY-MM-DD 23:59:59');
    return _this;
  }

  _createClass(ScheduleCase, [{
    key: "caseIdChange",
    value: function caseIdChange(val) {
      if (val) {
        this.getPartyList();
      }
    }
  }, {
    key: "getPersonList",
    // 获取人员信息
    value: function getPersonList() {
      var _this2 = this;

      apis.newUserList().then(function (res) {
        _this2.personList = res.data || [];
      }).then(function (_) {});
    } // 获取案件当事人信息

  }, {
    key: "getPartyList",
    value: function getPartyList() {
      var _this3 = this;

      apis.getInPersonInfos({
        caseId: this.caseId
      }).then(function (res) {
        // this.confMemberList = res.data.defendants.concat(res.data.plaintiffs).concat(res.data.thirds)
        _this3.confMemberList = res.data.all || [];

        var phones = _this3.confMemberList.map(function (item) {
          return item.phoneNo;
        });

        if (phones.length > 6) {
          _this3.form.confMember = phones.splice(0, 6);
        } else {
          _this3.form.confMember = phones;
        }
      }).then(function (_) {});
    } // 保存排期

  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this4 = this;

      var initHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var resolveHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var rejectHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var date = this.date;
      var _this$form = this.form,
          clerkId = _this$form.clerkId,
          chiefJudgeId = _this$form.chiefJudgeId;
      var _this$selectInfo = this.selectInfo,
          planStartTime = _this$selectInfo.planStartTime,
          planEndTime = _this$selectInfo.planEndTime,
          tribunalId = _this$selectInfo.tribunalId,
          tribunalName = _this$selectInfo.tribunalName;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 判断审判长和书记员是否选择同一人
          if (clerkId === chiefJudgeId) {
            _this4.$message("".concat(_this4.showNameMap.judge, "\u548C").concat(_this4.showNameMap.clerk, "\u4E0D\u80FD\u4E3A\u540C\u4E00\u4EBA"));

            return;
          } // 判断排期时间不能早于今天


          if (_this4.$moment(date).isBefore(new Date(), 'day')) {
            _this4.$message('排期时间不能早于今天');

            return;
          } // 判断开始时间和结束时间是否为空


          if (!planStartTime || !planEndTime) {
            _this4.$message('排期时间不能为空');

            return;
          }

          var p = _this4.saveSchedule();

          if (p) {
            initHandler();
            p.then(function (res) {
              resolveHandler();
            }).catch(function (_) {
              rejectHandler();
            });
          }
        }
      });
    } // 请求保存排期接口，如果参数通过，返回 promise

  }, {
    key: "saveSchedule",
    value: function saveSchedule() {
      var _this$selectInfo2 = this.selectInfo,
          planStartTime = _this$selectInfo2.planStartTime,
          planEndTime = _this$selectInfo2.planEndTime,
          tribunalId = _this$selectInfo2.tribunalId,
          tribunalName = _this$selectInfo2.tribunalName;
      var _this$form2 = this.form,
          clerkId = _this$form2.clerkId,
          chiefJudgeId = _this$form2.chiefJudgeId,
          confMember = _this$form2.confMember;
      var date = this.date; // 判断审判长和书记员是否选择同一人

      if (clerkId === chiefJudgeId) {
        this.$message('审判长和书记员不能为同一人');
        return false;
      } // 判断排期时间不能早于今天


      if (this.$moment(date).isBefore(new Date(), 'day')) {
        this.$message('排期时间不能早于今天');
        return false;
      } // 判断开始时间和结束时间是否为空


      if (!planStartTime || !planEndTime) {
        this.$message('排期时间不能为空');
        return false;
      }

      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        confMember: confMember.join(','),
        planDate: this.$moment(this.date).format('YYYY-MM-DD'),
        courtNo: this.$store.getters.userInfo.courtNo,
        caseIndexCodeList: new Array(this.caseId),
        planStartTime: planStartTime,
        planEndTime: planEndTime,
        tribunalId: tribunalId,
        tribunalName: tribunalName
      });

      return apis.save(params);
    } // 获取全部排期

  }, {
    key: "getAllSchedule",
    value: function getAllSchedule() {
      var _this5 = this;

      this.loading = true;
      var params = {
        pageSize: 10000,
        pageNo: 1,
        searchDateStart: this.searchStartTime,
        searchDateEnd: this.searchEndTime
      };
      apis.allSchedule(params).then(function (res) {
        _this5.allSchedule = res.data.list || [];
        _this5.loading = false;
      }).catch(function (_) {
        _this5.loading = false;
      });
    }
  }, {
    key: "chooseTime",
    value: function chooseTime(params) {
      var tribunalId = params.tribunalId,
          tribunalName = params.tribunalName,
          startTimeObj = params.startTimeObj,
          endTimeObj = params.endTimeObj;
      this.selectInfo = {
        planStartTime: startTimeObj.time,
        planEndTime: endTimeObj.time,
        tribunalId: tribunalId,
        tribunalName: tribunalName
      };
    }
  }, {
    key: "chooseStart",
    value: function chooseStart() {
      this.resetSelectInfo();
    }
  }, {
    key: "resetSelectInfo",
    value: function resetSelectInfo() {
      this.selectInfo = {
        planStartTime: '',
        planEndTime: '',
        tribunalName: '',
        tribunalId: ''
      };
    } // 更新日期

  }, {
    key: "dateChange",
    value: function dateChange(val) {
      this.date = val;
      this.searchStartTime = this.$moment(val).format('YYYY-MM-DD 00:00:00');
      this.searchEndTime = this.$moment(val).format('YYYY-MM-DD 23:59:59');
      this.getAllSchedule();
      this.resetSelectInfo();
      this.schdulePlan.reset();
    }
  }, {
    key: "created",
    value: function created() {
      this.getPersonList();
      this.getAllSchedule();
      this.form.chiefJudgeId = this.$store.getters.userInfo.userId;
    }
  }, {
    key: "selectMessage",
    get: function get() {
      var _this$selectInfo3 = this.selectInfo,
          planStartTime = _this$selectInfo3.planStartTime,
          planEndTime = _this$selectInfo3.planEndTime,
          tribunalName = _this$selectInfo3.tribunalName;

      if (planStartTime && planEndTime && tribunalName) {
        return "".concat(planStartTime, "~").concat(planEndTime, "  ").concat(tribunalName);
      }

      return '';
    }
  }, {
    key: "showNameMap",
    get: function get() {
      return this.$store.getters.showNameMap;
    }
  }]);

  return ScheduleCase;
}(Vue);

__decorate([Ref('schdulePlan')], ScheduleCase.prototype, "schdulePlan", void 0);

__decorate([Prop({
  required: true,
  default: ''
})], ScheduleCase.prototype, "caseId", void 0);

__decorate([Watch('caseId')], ScheduleCase.prototype, "caseIdChange", null);

ScheduleCase = __decorate([Component({
  components: {
    SchdulePlan: SchdulePlan
  }
})], ScheduleCase);
export default ScheduleCase;